export default "__VITE_ASSET__CbKp2fWq__"